<template>
  <v-card ref="list">
    <v-card-title>
      <p class="headline" style="padding-left: 16px; padding-top: 16px">
        <b>{{ size }}</b> {{ title }}
      </p>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <!--
      <vue-excel-xlsx
        :data="items"
        :columns="columns"
        :filename="'filename'"
        :sheetname="'sheetname'"
      >
        <v-icon>file_download</v-icon>Descargar datos
      </vue-excel-xlsx>
      -->
      <div @click="descargarFicheros()" style="margin-left: 10px">
        <v-icon>file_download</v-icon>Descargar ficheros
      </div>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :select-all="false"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <item-table
          :item="props.item"
          :selected="props.selected"
          @expand="props.expanded = !props.expanded"
        ></item-table>
      </template>
      <template slot="expand" slot-scope="props">
        <person-item
          :key="props.item.id"
          :person="props.item"
          :style="{
            width: width - 32 + 'px',
            position: 'sticky',
            left: '16px',
          }"
        ></person-item>
      </template>
      <template v-if="loading" slot="no-data">
        <v-alert :value="true" color="info" icon="info">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ItemTable from "./ItemTable";
import PersonItem from "./PersonItem";

export default {
  components: {
    ItemTable,
    PersonItem,
  },
  name: "campamentos",
  props: ["unidad"],
  data() {
    return {
      width: 0,
      loading: false,
      search: "",
      selected: [],
      title: "Scouts",
      headers: [
        { text: "Nombre", value: "name", align: "left" },
        { text: "Unidad", value: "unidad" },
        { text: "F. Nacimiento", value: "birthday" },
        { text: "Dias", value: "days" },
        { text: "Bus", value: "bus" },
        { text: "Alergias", value: "alergias" },
        { text: "Estado", value: "status" },
        { text: "Acciones", value: "name", sortable: false },
      ],
      items: [],

      columns: [
        {
          label: "Nombre",
          field: "name",
        },
        {
          label: "Apellido",
          field: "lastname",
        },
        {
          label: "Estado",
          field: "status",
        },
        {
          label: "IdPersona",
          field: "id",
        },
        {
          label: "Bus",
          field: "bus",
          dataFormat: this.excelBusFormat,
        },
      ],

      json_fields: {
        //Nombre: "name",
        //Apellido: "lastname",

        Estado: "status",
        IdPersona: "id",

        //Bus ida
        "Bus ida": {
          field: "bus", // nested attribute supported
          callback: (value) => {
            //Check if vuelta in list
            let outValue = "NO";
            if (value.includes("ida")) {
              outValue = "si";
            }

            return outValue;
          },
        },

        "15 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("15")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "16 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("16")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "17 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("17")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "18 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("18")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "19 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("19")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "20 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("20")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "21 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("21")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "22 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("22")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "23 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("23")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "24 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("24")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "25 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("25")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "26 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("26")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "27 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("27")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "28 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("28")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "29 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("29")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        "30 ": {
          field: "days",
          callback: (value) => {
            //Check if day in list
            let outValue = "";
            if (value.includes("30")) {
              outValue = "X";
            }

            return outValue;
          },
        },

        //Bus vuelta
        "Bus vuelta": {
          field: "bus", // nested attribute supported
          callback: (value) => {
            //Check if vuelta in list
            let outValue = "NO";
            if (value.includes("vuelta")) {
              outValue = "si";
            }

            return outValue;
          },
        },

        //Sanidad
        Enfermedades: "enfermedades",
        Operaciones: "operaciones",

        //Covid
        "Covid pasado": "covid_disease",
        "Covid vacunado": "covid_vaccine",

        //Otros
        Alergias: "alergias",
        Peso: "peso",
        Cumpleanos: "birthday",

        //Documentos
        Autorizacion: "autorizacion.0",
        "Seguridad social": "seguridad_social.0",
        Vacunas: "cartilla_vacunacion.0",
        "Mas documentos medicos": "docs.0",
      },
    };
  },

  firestore() {
    return {
      items: this.$db
        .collection("forms")
        .doc("inscripciones")
        .collection("people")
        .where("unidad", "==", this.unidad),
    };
  },

  watch: {
    items() {
      this.loading = false;
    },
    unidad() {
      this.loading = true; // <-- Añade esto
      //Al cambiar de unidad recargamos datos
      this.$firebase
        .firestore()
        .collection("forms")
        .doc("inscripciones")
        .collection("people")
        .where("unidad", "==", this.unidad)
        .get()
        .then((snapshot) => {
          var construccion = [];
          snapshot.forEach((doc) => {
            construccion.push(doc.data());
          });
          this.items = construccion;
        })
        .catch((err) => {
          console.log("Error getting documents", err);
          this.loading = false;
        });
    },
  },
  methods: {
    handleResize() {
      this.width = this.$refs.list.$el.offsetWidth;
    },
    descargarFicheros() {
      let listado_personas = this.items;

      let lista_archivos = [];

      for (let persona of listado_personas) {
        if (persona.autorizacion && persona.autorizacion[0]) {
          lista_archivos.push({
            nombre: persona.name,
            apellido: persona.lastname,
            tipoArchivo: "autorizacion",
            direccion: persona.autorizacion[0],
          });
        }
        if (persona.cartilla_vacunacion && persona.cartilla_vacunacion[0]) {
          lista_archivos.push({
            nombre: persona.name,
            apellido: persona.lastname,
            tipoArchivo: "vacunas",
            direccion: persona.cartilla_vacunacion[0],
          });
        }
        if (persona.seguridad_social && persona.seguridad_social[0]) {
          lista_archivos.push({
            nombre: persona.name,
            apellido: persona.lastname,
            tipoArchivo: "seguridad_social",
            direccion: persona.seguridad_social[0],
          });
        }
        //Otros documentos
        if (persona.docs && persona.docs[0]) {
          lista_archivos.push({
            nombre: persona.name,
            apellido: persona.lastname,
            tipoArchivo: "extra",
            direccion: persona.docs[0],
          });
        }
      }

      var storage = this.$firebase.storage();

      for (let [index, documento] of lista_archivos.entries()) {
        let nombreArchivo =
          documento.nombre +
          "_" +
          documento.apellido +
          "_" +
          documento.tipoArchivo;

        let terminacionArchivo = documento.tipoArchivo.split(".").pop();

        setTimeout(function () {
          console.log("Obteniendo el documento " + index);
          var storageRef = storage.ref(documento.direccion);
          //Download file by creating XMLHttpRequest
          storageRef.getDownloadURL().then((url) => {
            var xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = function (event) {
              //Create an `a` tag (since it has an `href` and a `download` attribute)
              var a = document.createElement("a");
              a.href = window.URL.createObjectURL(xhr.response);
              a.download = index + "_" + nombreArchivo + terminacionArchivo;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click(); //Simulates a click event
              var blob = xhr.response;
            };
            xhr.open("GET", url);
            xhr.send();
          });
        }, 1000 * index);
      }

      //Informar al usuario para que compruebe ejecucion
      alert(
        "Se van a descargar " +
          lista_archivos.length +
          " ficheros, por favor comprueba que el numero coincide con el de ficheros descargados."
      );
      console.log("Fin");
      console.log(lista_archivos);
    },
    excelBusFormat(value) {
      //Check if vuelta in list
      let outValue = "NO";
      if (value.includes("ida")) {
        outValue = "si";
      }

      return outValue;
    },
  },
  computed: {
    size() {
      return this.items.length !== 0 ? this.items.length : "";
    },
    nameFile() {
      var dateObj = new Date();
      var fileMonth = dateObj.getUTCMonth() + 1;
      if (fileMonth < 9) {
        fileMonth = "0" + fileMonth;
      }
      var fileDate =
        dateObj.getUTCFullYear() + "-" + fileMonth + "-" + dateObj.getUTCDate();
      return "Resumen_" + this.unidad + "_" + fileDate;
    },
  },
  mounted: function () {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    console.log("mounted");
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
</style>